import React from 'react';
import { GradeSyncLink } from './gradeSyncPath';
import SPARowList from '../shared/SPARowList';
import type { OverviewPayload } from './useSyncOverview';

/** The teachers absorbing the most rejected posts, each a way in to their page. */
const MostRejectedTeachers = ({ teachers }: { teachers: NonNullable<OverviewPayload['teachers']> }) => (
  <SPARowList>
    {teachers.map(teacher => (
      <div key={teacher.staffer_id} className="tw-flex tw-items-baseline tw-gap-2 tw-text-sm">
        <GradeSyncLink to={`/teachers/${teacher.staffer_id}`}>
          {teacher.name ?? `Staffer ${teacher.staffer_id}`}
        </GradeSyncLink>
        <span className="tw-text-spa-secondary">{teacher.subscriber ?? '—'}</span>
        <span className="tw-ml-auto tw-tabular-nums tw-text-spa-secondary">
          {`${teacher.failures.toLocaleString()} rejected`}
        </span>
      </div>
    ))}
  </SPARowList>
);

export default MostRejectedTeachers;
